<!--@format-->
<div class="form-horizontal phone-form-horizontal">
   <div
      class="input-group"
      style="padding: 8px; width: 40%; min-width: 420px"
      *ngIf="selectedNode !== undefined && selectedNode !== null && !isOnlyPreview"
   >
      <p-dropdown
         [options]="displayTemplateParameters"
         [(ngModel)]="selectedTemplateParameter"
         styleClass="form-control insert-parameter-dropdown"
      >
         <ng-template let-item pTemplate="item">
            <div *ngIf="item.label.indexOf('hr') === -1">{{ item.label }}</div>
            <div *ngIf="item.label.indexOf('hr') !== -1"><hr /></div>
         </ng-template>
      </p-dropdown>
      <button
         class="btn btn-primary border-left-flat"
         style="height: 36px; min-width: 160px"
         (click)="
            contenteditableDirective.addParameter(
               selection,
               templateParameters,
               selectedTemplateParameter,
               selectedNode
            )
         "
         tooltip="This will be replaced at the time of sending the message"
      >
         Insert parameter
      </button>
   </div>
</div>

<div class="phone-container-img">
   <div class="phone-header header-left">
      Characters: <span [ngClass]="{ blinking: maxReached }">{{ smsTextLength }}</span
      >/480
   </div>
   <div class="phone-header header-right">Messages: {{ getMessagesByCharacters() }}</div>
   <div
      contenteditable
      (click)="setSelectedNode($event)"
      [attr.contenteditable]="!isOnlyPreview"
      [ng-model]="'smsMessage'"
      class="phone-body"
      [disablePasteEvent]="disablePasteEvent"
      limit-paste="true"
      strip-br="false"
      strip-nbsp="true"
      strip-html="true"
      [innerHTML]="smsText | safe: 'html'"
      id="template.smsMessage"
      (blur)="setSelectedData()"
      (keyup)="calculateTest($event.currentTarget.innerHTML)"
   ></div>
</div>
